import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { BUTTON_SIZES, PrimaryButton, SecondaryButton } from 'ui/button';
import { WarningNoFill } from 'ui/icons';
import { Caption, colors, spacing } from 'ui/theme';
import { AlertsModalType, useAlertsModalContext } from '../../context';
import { AlertsPageCard } from '../AlertsPageCard';
import { MessageMediumTabs } from './MessageMediumTabs';

const AlertUnsavedChanges = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

const CaptionSecondary = styled(Caption)`
  color: ${colors.textSecondary};
  text-align: center;
`;

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

const ButtonsWrapper = styled.div`
  display: inline-flex;
  gap: ${spacing.half};
`;

export const CAMPAIGN_ALERT_DEFAULTS_CARD_ID = 'campaign-alerts-defaults-card';
export const UPDATE_ALERTS_BUTTON_ID = 'update-alerts-button';
export const CANCEL_UPDATE_ALERTS_BUTTON_ID = 'campaign-alerts-cancel-update-alerts-button';
export const UNSAVED_CHANGES_WARNING = 'campaign-alerts-unsaved-changes-warning';

export const CampaignAlertDefaultsCard = () => {
  const { openModal } = useAlertsModalContext();
  const {
    formState: { isDirty, isValid },
    reset,
  } = useFormContext();

  return (
    <AlertsPageCard
      data-test={CAMPAIGN_ALERT_DEFAULTS_CARD_ID}
      title={'Campaign alert defaults'}
      description={
        'Set default alert preferences for campaigns, which will be automatically applied to new campaigns of that type and channel.'
      }
      actions={
        <ActionsWrapper>
          {isDirty && (
            <AlertUnsavedChanges data-test={UNSAVED_CHANGES_WARNING}>
              <WarningNoFill color={colors.warning100} />
              <CaptionSecondary>There are unsaved changes</CaptionSecondary>
            </AlertUnsavedChanges>
          )}

          <ButtonsWrapper>
            {isDirty && (
              <SecondaryButton
                onClick={() => reset()}
                size={BUTTON_SIZES.SMALL}
                data-test={CANCEL_UPDATE_ALERTS_BUTTON_ID}
              >
                Cancel
              </SecondaryButton>
            )}

            <PrimaryButton
              data-test={UPDATE_ALERTS_BUTTON_ID}
              isDisabled={!isDirty || !isValid}
              onClick={() => openModal(AlertsModalType.UpdateAlertsModal)}
              size={BUTTON_SIZES.SMALL}
            >
              Save
            </PrimaryButton>
          </ButtonsWrapper>
        </ActionsWrapper>
      }
    >
      <MessageMediumTabs />
    </AlertsPageCard>
  );
};
